export default function PHP_filter_input() {
  return (
    <div>
      <h1>PHP_filter_input</h1>
    </div>
  );
}
